import { CommonModule, DatePipe, NgClass, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormControl, FormsModule } from '@angular/forms'
import { DateInputFillMode, DateInputSize, KENDO_DATEPICKER } from '@progress/kendo-angular-dateinputs'
import { KENDO_DROPDOWNLIST, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { ColumnComponent, ExcelExportComponent } from '@progress/kendo-angular-excel-export'
import { CellTemplateDirective, KENDO_GRID_EXCEL_EXPORT } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { ToastrService } from 'ngx-toastr'
import { AlertService } from '../../../@theme/services/alert.service'
import { ReportsService } from '../../../@theme/services/reports.service'
interface Item {
  text: string
  value: string
}
interface Itemlist {
  text: string
  value: number
}
@Component({
  selector: 'gd-ngx-transreports',
  templateUrl: './transactionreports.component.html',
  styleUrls: ['./transactionreports.component.scss'],
  imports: [
    CommonModule,
    KENDO_DATEPICKER,
    FormsModule,
    KENDO_DROPDOWNLIST,
    KENDO_DROPDOWNS,
    KENDO_INPUTS,
    KENDO_GRID_EXCEL_EXPORT,
    NgIf,
    NgClass,
    ExcelExportComponent,
    ColumnComponent,
    CellTemplateDirective,
    DatePipe,
  ]
})
export class TransReportsComponent implements OnInit {
  public selectedSize: DateInputSize = 'large'
  public sizes: DateInputSize[] = ['small', 'medium', 'large']
  public selectedFillMode: DateInputFillMode = 'solid'
  public fillModes: DateInputFillMode[] = ['solid', 'flat', 'outline']
  private currentDate = new Date()
  private thirtyDaysAgo = new Date(
    this.currentDate.setDate(this.currentDate.getDate() - 30),
  )
  //     { text: 'Deleted Blotter Transactions', value: 3 },
  public listItems: Array<Itemlist> = [
    { text: 'All Transactions', value: 0 },
    { text: 'Non-Rep Entered Transactions', value: 1 },
    { text: 'Summary of Non-Rep Entered Transactions', value: 2 },
  ]
  public selectedItem: Itemlist = this.listItems[0]
  public startdate = new FormControl(this.thirtyDaysAgo)
  buttonState = 'default-button'
  public thisselected: boolean
  public selectedValue: any
  public Nontransaction = false
  enddate = new FormControl(new Date())
  gridExcelexport: any[] = []
  gridExcelexportsummary: any[] = []
  gridExcelexportDeleted: any[] = []
  ngModelDate = new Date()
  ngModelendDate = new Date()
  public aggregates: any[] = []
  constructor(
    private ur: AlertService,
    private toastrService: ToastrService,
    private reportService: ReportsService,
  ) {
    this.thisselected = false
    const today = new Date()
    this.ngModelDate = this.thirtyDaysAgo
    this.ngModelendDate = today
  }
  ngOnInit(): void {
    this.selectedValue = 0
  }
  ExportToExcelDelete() {
    this.showToast('success', 'Preparing variable annuity age report for download...');
    
    // Parameters for the report
    const params = {
      repId: 0,
      branchNumber: '',
      startDate: this.ngModelDate,
      endDate: this.ngModelendDate,
      reportTypeId: 2
    };
    
    // Use the AlertService instead of direct XMLHttpRequest
    this.ur.getvaribleAnnunityAge(params).subscribe(
      (blobResponse) => {
        console.log('Response received, type:', blobResponse.type);
        console.log('Response size:', blobResponse.size, 'bytes');
        
        if (blobResponse.size === 0) {
          this.showToast('warning', 'No data available for the selected date range.');
          return;
        }
        
        // Download the file
        const fileName = 'TransactionsSummary.csv';
        this.downloadFile(blobResponse, fileName);
      },
      (error) => {
        console.error('Error downloading data:', error);
        this.showToast('error', 'Failed to download Transaction Summary. Please try again.');
      }
    );
  }
  onMouseEnter() {
    this.buttonState = 'hover-button'
  }

  onMouseLeave() {
    this.buttonState = 'default-button'
  }
  getBlotterExport(component) {
    const Param = {
      Startdate: this.ngModelDate,
      Enddate: this.ngModelendDate,
      blotterfilter: Number(this.selectedValue),
    }

    this.ur.getBlotterExportReportsAll(Param).subscribe((r) => {
      this.gridExcelexport = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  getAccessreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getDeletedBlottersReports(Param).subscribe((r) => {
      this.gridExcelexportDeleted = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    this.showToast('success', 'Please wait, your Excel is being downloaded.')
    component.save(options)
  }
  ExportToExcel(component) {
    if (this.selectedValue === 0) {
      // All Transactions
      this.showToast('success', 'Please wait, retrieving All Transactions data...');
      
      const params = {
        Startdate: this.ngModelDate,
        Enddate: this.ngModelendDate,
        blotterfilter: 0
      };
      
      // Use the AlertService instead of direct XMLHttpRequest
      this.ur.getBlotterExportReportsAll(params).subscribe(
        (blobResponse) => {
          console.log('Response received, type:', blobResponse.type);
          console.log('Response size:', blobResponse.size, 'bytes');
          
          if (blobResponse.size === 0) {
            this.showToast('warning', 'No data available for the selected date range.');
            return;
          }
          
          // Download the file
          const fileName = 'AllTransactions.csv';
          this.downloadFile(blobResponse, fileName);
        },
        (error) => {
          console.error('Error downloading data:', error);
          this.showToast('error', 'Failed to download All Transactions. Please try again.');
          
          // Fall back to original method if service fails
          this.getBlotterExport(component);
        }
      );
    } else if (this.selectedValue === 1) {
      // Non-Rep Entered Transactions
      this.showToast('success', 'Please wait, retrieving Non-Rep Entered Transactions...');
      
      const params = {
        Startdate: this.ngModelDate,
        Enddate: this.ngModelendDate,
        blotterfilter: 1
      };
      
      // Use the AlertService method for Non-Rep Entered Transactions
      this.ur.getAccessTrasactionReports(params).subscribe(
        (blobResponse) => {
          console.log('Response received, type:', blobResponse.type);
          console.log('Response size:', blobResponse.size, 'bytes');

          if (blobResponse.size === 0) {
            this.showToast('warning', 'No data available for the selected date range.');
            return;
          }

          // Download the file
          const fileName = 'NonRepTransactions.csv';
          this.downloadFile(blobResponse, fileName);
        },
        (error) => {
          console.error('Error downloading data:', error);
          this.showToast('error', 'Failed to download Non-Rep Transactions. Please try again.');
        }
      );
    } else if (this.selectedValue === 2) {
      // Summary of Non-Rep Entered Transactions
      this.ExportToExcelDelete();
    } else if (this.selectedValue === 3) {
      // Deleted Blotter Transactions
      this.ExportToExcelDeleted(component);
    }
  }
  public selectionChange(value: any): void {
    this.selectedValue = value.value
  }
  getAccessexportreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getDeletedExportBlottersReports(Param).subscribe((r) => {
      if (Array.isArray(r) && r.length === 0) {
        this.showToast(
          'error',
          'Sorry there is no data. Please choose a date further back.',
        )
        return
      }
      this.gridExcelexportDeleted = r
      this.showToast(
        'success',
        'Please wait, We are retrieving your information',
      )
      setTimeout(() => this.returndata(component), 3000)
    })
  }

  downloadFile(file: Blob, fileName: string) {
    try {
/*       console.log('Download starting for:', fileName);
      console.log('Blob type:', file.type);
      console.log('Blob size:', file.size, 'bytes'); */
      
      // Check if file is valid
      if (!file || file.size === 0) {
        this.showToast('error', 'The downloaded file is empty or invalid.');
        return;
      }
      
      // Force the correct MIME type for CSV regardless of what was returned
      // This is crucial for ASP.NET Core FileResult handling
      const csvBlob = new Blob([file], { type: 'text/csv;charset=utf-8' });
      
      // Method 1: Try to use the direct browser download approach
      try {
        const url = window.URL.createObjectURL(csvBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          console.log('Browser download completed');
        }, 100);
      } catch (directError) {
        console.error('Browser download failed:', directError);
        throw directError; // Re-throw for outer catch
      }
      
      this.showToast('success', `${fileName} has been downloaded successfully.`);
    } catch (error) {
      console.error('Download file error:', error);
      this.showToast('error', 'Failed to download the file. Please try again.');
    }
  }
  ExportToExcelDeleted(component) {
    this.showToast('success', 'Please wait, retrieving deleted transactions data...');
    
    const params = {
      Startdate: this.ngModelDate,
      Enddate: this.ngModelendDate,
      blotterfilter: 3 // Deleted transactions filter
    };
    
    // Use the AlertService instead of direct XMLHttpRequest
    this.ur.getBlotterExportReportsAll(params).subscribe(
      (blobResponse) => {
        console.log('Response received, type:', blobResponse.type);
        console.log('Response size:', blobResponse.size, 'bytes');
        
        if (blobResponse.size === 0) {
          this.showToast('warning', 'No deleted transactions found in the selected date range.');
          return;
        }
        
        // Download the file
        const fileName = 'DeletedTransactions.csv';
        this.downloadFile(blobResponse, fileName);
      },
      (error) => {
        console.error('Error downloading deleted transactions:', error);
        this.showToast('error', 'Failed to download deleted transactions. Trying alternate method...');
        
        // Fallback to original method
        this.getAccessexportreports(component);
      }
    );
  }
  /**
   * Reorders (and trims) the columns of a CSV string to the given ordered list of
   * header names. Columns not present in `order` are dropped; a requested header not
   * found in the source produces an empty column. Handles quoted fields that contain
   * commas, doubled quotes and embedded newlines.
   */
  reorderCsvColumns(csvText: string, order: string[]): string {
    const rows = this.parseCsv(csvText)
    if (rows.length === 0) {
      return csvText
    }

    const header = rows[0].map((h) => (h ?? '').trim())
    const indexByName = new Map<string, number>()
    header.forEach((name, i) => {
      if (name !== '' && !indexByName.has(name)) {
        indexByName.set(name, i)
      }
    })
    const targetIdx = order.map((name) =>
      indexByName.has(name) ? (indexByName.get(name) as number) : -1,
    )

    const outLines: string[] = []
    outLines.push(order.map((name) => this.csvEscape(name)).join(','))
    for (let r = 1; r < rows.length; r++) {
      const row = rows[r]
      // Skip stray empty lines some CSV writers append.
      if (row.length === 1 && row[0] === '') {
        continue
      }
      const cells = targetIdx.map((idx) => (idx >= 0 && idx < row.length ? row[idx] : ''))
      outLines.push(cells.map((c) => this.csvEscape(c ?? '')).join(','))
    }
    return outLines.join('\r\n')
  }

  /** Quotes a value when it contains a comma, quote or newline (RFC 4180). */
  private csvEscape(value: string): string {
    const v = value == null ? '' : String(value)
    if (/[",\r\n]/.test(v)) {
      return '"' + v.replace(/"/g, '""') + '"'
    }
    return v
  }

  /** Minimal RFC 4180 CSV parser: returns rows, each an array of field strings. */
  private parseCsv(text: string): string[][] {
    const rows: string[][] = []
    let field = ''
    let row: string[] = []
    let inQuotes = false
    let i = 0
    const n = text.length
    while (i < n) {
      const ch = text[i]
      if (inQuotes) {
        if (ch === '"') {
          if (text[i + 1] === '"') {
            field += '"'
            i += 2
            continue
          }
          inQuotes = false
          i++
          continue
        }
        field += ch
        i++
        continue
      }
      if (ch === '"') {
        inQuotes = true
        i++
        continue
      }
      if (ch === ',') {
        row.push(field)
        field = ''
        i++
        continue
      }
      if (ch === '\r') {
        row.push(field)
        field = ''
        rows.push(row)
        row = []
        i += text[i + 1] === '\n' ? 2 : 1
        continue
      }
      if (ch === '\n') {
        row.push(field)
        field = ''
        rows.push(row)
        row = []
        i++
        continue
      }
      field += ch
      i++
    }
    if (field !== '' || row.length > 0) {
      row.push(field)
      rows.push(row)
    }
    return rows
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}


